import { Text } from '@change/ds-core-ui';
import { Form, TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { StepActions } from '#src/app/pages/startAPetitionV2/shared/components';

import { useIssuePrompt } from './hooks/useIssuePrompt';

export const IssuePrompt: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = useIssuePrompt();

	return (
		<div
			className="container mx-auto mb-[88px] flex max-w-[620px] flex-col gap-6 px-5 py-8 md:gap-12"
			data-qa="issue-prompt"
		>
			<div className="grid gap-4">
				<Text as="h1" variant="heading" className="m-0">
					<Translate value="corgi.start_a_petition.issue_prompt.heading" />
				</Text>

				<Text as="p" variant="body" size="large">
					<Translate value="corgi.start_a_petition.issue_prompt.description" />
				</Text>
			</div>

			<Form
				onSubmit={actions.submit}
				schema={data.schema}
				defaultValues={data.defaultValues}
				className="grid gap-6 md:gap-12"
				data-qa="issue-prompt-form"
			>
				<TextField
					label={translate('corgi.start_a_petition.issue_prompt.issue_input_label')}
					inputElementType="textarea"
					name="issue"
					size="large"
					boldLabel
					maxLength={500}
					placeholder={translate('corgi.start_a_petition.issue_prompt.issue_input_placeholder')}
					inputOptions={{
						onBlur: actions.persistDraft,
					}}
				/>

				<StepActions type="form" onSecondaryAction={actions.back} />
			</Form>
		</div>
	);
};
